import {
  Container,
  Card,
  Col,
  Row,
  CardBody,
  UncontrolledTooltip,
} from "reactstrap";
import { PAGE_TITLES } from "../Common/constants";
import BreadCrumb from "../Common/BreadCrumb";
import PieChart from "./ApexpieChart";
import AreaChart from "./AreaChart";
import BarChart from "./BarChart";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getMvnoDashboard } from "../../slices/MvnoDashboard/thunk";
import { usePlans } from "../LightWeightCustomer/Constant/dashboardUtil";
import { Loader } from "../Utils/Loader";
import noData from "../../assets/images/NoData.gif";
import { setWelcomeToast } from "../../slices/welcomeToaster/action";
import { ToastContainer, toast } from "react-toastify";
import { formatNumber } from "./constantFunctions";
import { setPasswordSuccessMessage } from "../../slices/toastMessage/action";

export default function MvnoDashboard() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  let CombinedData = [];
  useEffect(() => {
    dispatch(getMvnoDashboard(setLoading));
  }, []);
  const mvnodashbaordvalue = useSelector(
    (state) => state.GetMvnoDashboard.getMvnoDashboard
  );
  const showWelcomeToast = useSelector(function (state) {
    return state.welcomeToast.showWelcomeToast;
  });
  const showPasswordSuccessMessage = useSelector(
    (state) => state.SuccessToast.showPasswordSuccessMessage
  );
  const plans = usePlans(setLoading);
  const initialMonthlyData = mvnodashbaordvalue?.[0];
  if (mvnodashbaordvalue?.length > 0) {
    CombinedData = [...initialMonthlyData.activeCustomers.monthlyBreakdown];
  }
  CombinedData.sort((a, b) => {
    if (a.Year !== b.Year) {
      return a.Year - b.Year;
    } else {
      const monthsOrder = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return monthsOrder.indexOf(a.Month) - monthsOrder.indexOf(b.Month);
    }
  });
  const ActivecustomerData = CombinedData.map((data) => ({
    x: data.Month,
    y:
      initialMonthlyData.activeCustomers.monthlyBreakdown.find(
        (item) => item.Month === data.Month && item.Year === data.Year
      )?.CustomerCount || 0,
  }));
  const inactiveCustomerdata = CombinedData.map((data) => ({
    x: data.Month,
    y:
      initialMonthlyData.inactiveCustomers.monthlyBreakdown.find(
        (item) => item.Month === data.Month && item.Year === data.Year
      )?.CustomerCount || 0,
  }));
  const offerNames = Array.isArray(plans)
    ? plans.map((offer) => offer?.offerName)
    : [];
  const offerCounts = Array.isArray(plans)
    ? plans.map((offer) => offer?.count)
    : [];
  const PieChartActiveCustomerData =
    initialMonthlyData?.activeCustomers?.totalCustomers || 0;
  const PieChartInactiveCustomerData =
    initialMonthlyData?.inactiveCustomers?.totalCustomers || 0;
  const PieChartTotalData =
    PieChartActiveCustomerData + PieChartInactiveCustomerData;

  useEffect(
    function () {
      if (showWelcomeToast) {
        toast.success(`Welcome ${localStorage.getItem("userName")}`);
        dispatch(setWelcomeToast(false));
      } else if (showPasswordSuccessMessage) {
        toast.success(`Password Changed Successfully`);
        dispatch(setPasswordSuccessMessage(false));
      }
    },
    [showWelcomeToast, dispatch]
  );

  const formattedNumber = formatNumber(PieChartTotalData);
  const operatorConfiguration = useSelector(
    (state) =>
      state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration
  );

  const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;

  const buttonLabel = isEIPEnabled ? "devices" : "customers";
  const buttonLabel1 = isEIPEnabled ? "Devices" : "Customers";
  const buttonName = isEIPEnabled ? "Device Analytics" : "Customer Analytics";
  const buttonTotal = isEIPEnabled ? "Device Overview" : "Customer Overview";

  return (
    <div className="page-content">
      <Container fluid>
        <ToastContainer position="top-center" />
        {loading && <Loader />}
        <BreadCrumb title={PAGE_TITLES.MVNO_DASHBOARD} />
        <Row className="g-3">
          <div>
            <div className="d-flex justify-content-between">
              <div className="fs-5 me-3 ms-0 fw-semibold rv-text-color">
                {buttonName}
              </div>
            </div>
          </div>

          <Col xxl={3} md={6}>
            <div className="mb-3 border border-1 border-dark-subtle rounded-1 h-100 align-content-center pb-2">
              <div className="d-flex flex-column justify-content-left align-items-left">
                <div className="fs-5 me-3 ms-3 mt-3 fw-semibold rv-text-color">
                  New {buttonLabel1}<span id={"mtdLabelNew"}> (MTD) </span>
                  <UncontrolledTooltip target={"mtdLabelNew"}>
                    Month to Date
                  </UncontrolledTooltip>
                </div>
                <div
                  className="fs-1 me-3 ms-3 mt-3 fw-semibold mb-2"
                  style={{ color: "#02B202" }}
                >
                  {mvnodashbaordvalue?.[0]?.activeCustomers?.currentMonthTotal ||
                    0}
                </div>
              </div>
            </div>
          </Col>
          <Col xxl={3} md={6}>
            <div className="mb-3 border border-1 border-dark-subtle rounded-1 h-100 align-content-center pb-2">
              <div className="d-flex flex-column justify-content-left align-items-left">
                <div className="fs-5 me-3 ms-3 mt-3 fw-semibold rv-text-color">
                  New {buttonLabel1} <span id={"ytdLabelNew"}> (YTD) </span>
                  <UncontrolledTooltip target={"ytdLabelNew"}>
                    Year to Date
                  </UncontrolledTooltip>
                </div>
                <div
                  className="fs-1 me-3 ms-3 mt-3 fw-semibold mb-2"
                  style={{ color: "#02B202" }}
                >
                  {mvnodashbaordvalue?.[0]?.activeCustomers?.currentYearTotal ||
                    0}
                </div>
              </div>
            </div>
          </Col>
          <Col xxl={3} md={6}>
            <div className="mb-3 border border-1 border-dark-subtle rounded-1 h-100 align-content-center pb-2">
              <div className="d-flex flex-column justify-content-left align-items-left">
                <div className="fs-5 me-3 ms-3 mt-3 fw-semibold rv-text-color">
                  Closed {buttonLabel1} <span id={"mtdLabelClosed"}> (MTD) </span>
                  <UncontrolledTooltip target={"mtdLabelClosed"}>
                    Month to Date
                  </UncontrolledTooltip>
                </div>
                <div
                  className="fs-1 me-3 ms-3 mt-3 fw-semibold mb-2"
                  style={{ color: "#DC3911" }}
                >
                  {mvnodashbaordvalue?.[0]?.inactiveCustomers
                    ?.currentMonthTotal || 0}
                </div>
              </div>
            </div>
          </Col>
          <Col xxl={3} md={6}>
            <div className="mb-3 border border-1 border-dark-subtle rounded-1 h-100 align-content-center pb-2">
              <div className="d-flex flex-column justify-content-left align-items-left">
                <div className="fs-5 me-3 ms-3 mt-3 fw-semibold rv-text-color">
                  Closed {buttonLabel1} <span id={"ytdLabelClosed"}> (YTD) </span>
                  <UncontrolledTooltip target={"ytdLabelClosed"}>
                    Year to Date
                  </UncontrolledTooltip>
                </div>
                <div
                  className="fs-1 me-3 ms-3 mt-3 fw-semibold mb-2"
                  style={{ color: "#DC3911" }}
                >
                  {mvnodashbaordvalue?.[0]?.inactiveCustomers?.currentYearTotal ||
                    0}
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mb-3 gx-3">
          <Col xxl={6}>
            <div className="border border-1 border-dark-subtle rounded-1 mt-3 pb-4">
              <div className="d-flex justify-content-between">
                <div className="fs-5 me-3 ms-3 mt-3 fw-semibold rv-text-color">
                  {buttonTotal}
                </div>
              </div>
              <Row className="mt-4 ms-1">
                <Col xxl={6} md={6}>
                  <div className="mt-3 position-relative">
                    <p className="fs-2 fw-semibold mvno-text-color position-absolute top-50 start-50 translate-middle mt-n2">
                      {formattedNumber}
                    </p>
                    <p className="fs-6 fw-semibold mt-3 position-absolute top-50 start-50 translate-middle">
                      {buttonLabel}
                    </p>
                    <PieChart
                      PieChartActiveCustomerData={PieChartActiveCustomerData}
                      PieChartInactiveCustomerData={
                        PieChartInactiveCustomerData
                      }
                    />
                  </div>
                </Col>
                <Col xxl={6} md={6} className="text-center text-xxl-start">
                  <div className="d-flex flex-column align-items-center align-items-xxl-start">
                    <div className="d-flex align-items-center mt-5">
                      <div className="fs-6 fw-medium ms-0">
                        Total {buttonLabel1} :{" "}
                        {(mvnodashbaordvalue?.[0]?.activeCustomers
                          ?.totalCustomers || 0) +
                          (mvnodashbaordvalue?.[0]?.inactiveCustomers
                            ?.totalCustomers || 0)}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column align-items-center align-items-xxl-start">
                    <div className="d-flex align-items-center mt-3">
                      <span
                        className="color-box"
                        style={{ backgroundColor: "#2E5B88" }}
                      ></span>
                      <div className="fs-6 fw-medium ms-2">
                        Active {buttonLabel1}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column align-items-center align-items-xxl-start">
                    <div className="d-flex align-items-center mt-3">
                      <span
                        className="color-box"
                        style={{ backgroundColor: "#9FCAE6" }}
                      ></span>
                      <div className="fs-6 fw-medium ms-2">
                        Closed {buttonLabel1}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          <Col xxl={6}>
            <div className="border border-1 border-dark-subtle rounded-1 mt-3 pb-1">
              <div className=" d-flex justify-content-between">
                <p className="fs-5 me-3 ms-3 mt-3 fw-semibold rv-text-color">
                  {buttonLabel1} Trends
                </p>
                <p className=" d-flex justify-content-center align-items-end mx-3 mt-3">
                  <i className="ri-error-warning-line mx-2"></i> Data of last 6
                  months
                </p>
              </div>
              <div className="">
                {ActivecustomerData &&
                inactiveCustomerdata &&
                ActivecustomerData.length > 0 &&
                inactiveCustomerdata.length > 0 ? (
                  <AreaChart
                    activeCustomerData={ActivecustomerData}
                    inactiveCustomerData={inactiveCustomerdata}
                  />
                ) : (
                  <div
                    style={{ height: "267px" }}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <img src={noData} width={250} alt="No Data" />
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
        <Row className="g-3">
          <Col className="mb-3">
            <div className="border border-1 border-dark-subtle rounded-1 mt-0 pb-4">
              <div className=" d-flex justify-content-between">
                <p className=" fs-5 me-3 ms-3 mt-3 fw-semibold rv-text-color">
                  Top Plans
                </p>
                <p className=" d-flex pe-2 justify-content-center align-items-end mx-3 mt-3">
                  <i className="ri-error-warning-line mx-2"></i> Data of last 6
                  months
                </p>
              </div>
              <div className="pe-3">
                {offerCounts &&
                offerNames &&
                offerCounts.length > 0 &&
                offerNames.length > 0 ? (
                  <BarChart offerNames={offerNames} offerCounts={offerCounts} />
                ) : (
                  <div
                    style={{ height: "400px" }}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <img src={noData} width={320} alt="No Data" />
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
